import { PrinterType } from 'models'
import { NetworkPrinterWritterType } from 'models/NetworkPrinterWritterType'

interface DeviceStatusRequestPayload {
    requestId: string
}

export enum DeviceType {
    Printer = 1,
    CustomerFacingDisplay = 2,
}

export enum PrinterStatusType {
    OK,
    Error,
    Checking,
    Unknown,
}

export interface PrinterSettings {
    printerID: string
    printerType: PrinterType
    iPAddress?: string | null
    port?: number | null
    com?: string | null
    baudRate?: number | null
    pid?: number | null
    vid?: number | null
    /**
     * @type {number}
     * @memberof PrinterSettings
     */
    printImageDelay?: number | null
    /**
     * @type {number}
     * @memberof PrinterSettings
     */
    printCoolDownDelay?: number | null
    /**
     * @type {NetworkPrinterWritterType}
     * @memberof PrinterSettings
     */
    networkPrinterWritterType?: NetworkPrinterWritterType | null
    /// <summary>
    /// Location ID of the printer, this is used to identify the location of the printer
    /// It is only used for certain events.
    /// </summary>
    locationID?: string | null
}

export interface PrinterCheckStatusPayload extends DeviceStatusRequestPayload {
    printers: PrinterSettings[]
}

export interface GetPrinterStatusPayload {
    printer: PrinterSettings
}

export enum DeviceStatusEventType {
    /**
     * when receive 'OnUpdateStatus' which currently used in Printer lookup page. HW Agent will fetch printers status without making the subscription.
     * when HW agent complete check status on each printer, it trigger this event one by one.
     */
    SingleStatusCheck,
    /**
     * when received printer status updates (all subscribed printers) from HW Agent
     */
    OnPulseBatchStatus,
    /**
     * when received printer status updates (delta changes) from HW Agent
     */
    OnSelectiveUpdateStatus,
    /**
     * when connected/reconnected to HW Agent but no printer setting in current location
     */
    NoPrinterSetting,
    /**
     * when HW agent is disconnected
     */
    Disconnected,
    /**
     * when receive Caller.ID message
     */
    OnReceiveCallerId,
}

export type DeviceStatusMessage =
    | {
          eventType: DeviceStatusEventType.NoPrinterSetting
          data: null
      }
    | {
          eventType: DeviceStatusEventType.OnPulseBatchStatus
          data: DeviceStatusResult[]
      }
    | {
          eventType: DeviceStatusEventType.OnSelectiveUpdateStatus
          data: DeviceStatusResult[]
      }
    | {
          eventType: DeviceStatusEventType.SingleStatusCheck
          data: DeviceStatusResult
      }
    | {
          eventType: DeviceStatusEventType.Disconnected
          data: null
      }
    | {
          eventType: DeviceStatusEventType.OnReceiveCallerId
          data: CallerIdMessage
      }

export interface DeviceStatusResult {
    requestID: string
    type: DeviceType
    referenceID: string
    isOK: boolean
    errors: string[]
    extras: any
    /// <summary>
    /// Location ID of the printer, this is used to identify the location of the printer
    /// It is only used for certain events.
    /// </summary>
    locationID?: string | null
}

export interface PrinterStatus {
    status: PrinterStatusType
    errors: string[]
}

export interface CallerIdMessage {
    phoneNumber?: string | null
    callerName?: string | null
    time?: string | null
    lineNumber?: string | null
    io?: string | null
    se?: string | null
}
